import { useFormik } from 'formik';
import React, { useRef, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { string_required } from '../../../validation/validationSchema';
import {
  editKYCDetails,
  fetchMediaURL,
  profType,
  proofTypeID,
} from '../../../api-services';
import swal from 'sweetalert';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import PreviewImages from './components/PreviewImages';
import { Country } from 'country-state-city';

const initialState = {
  first_name: '',
  last_name: '',
  user_city: '',
  user_country: '',
  type: 'Personal',
  address: '',
  postal_code: '',
  address_proof: '',
  company_name: '',
  registration_num: '',
  proof_type_id: '',
  address_proof_type_id: '',
  proof_type_id: '',
  vat_id: '',
  personal_tax_id: '',
};
const validationSchema = Yup.object({
  first_name: string_required,
  last_name: string_required,
  user_city: string_required,
  user_country: string_required,
  type: string_required,
  address: string_required,
  postal_code: string_required,
  address_proof_type_id: string_required,
  proof_type_id: string_required,
});

const KycEditModal = ({
  viewKyc,
  kycData,
  setviewKyc,
  setviewKycEdit,
  dataAddressProofType = [],
  dataProofTypeID = [],
}) => {
  const queryClient = useQueryClient();
  const [initialValues, setInitialValues] = useState(initialState);
  const fileRef = useRef(null);
  const fileProofRef = useRef(null);
  const [filePreview, setFilePreview] = useState([]);
  const [filePreviewProof, setFilePreviewProof] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });
  const typeOfProfile = formik?.values?.type;

  const handleClose = () => {
    setviewKyc(false);
    setviewKycEdit(false);
  };

  const { isLoading: isLoadingUpdate, mutate: mutateUpdate } = useMutation(
    'update-kyc-details',
    (payload) => editKYCDetails(payload),
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('getFranceRequestedList');
          handleClose();
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  function handleSubmitForm(values) {
    const {
      first_name,
      last_name,
      user_city,
      user_country,
      address,
      postal_code,
      company_name,
      registration_num,
      proof_type_id,
      address_proof_type_id,
      type,
      vat_id,
      personal_tax_id,
    } = values;
    const payload = {
      first_name,
      last_name,
      user_city,
      user_country,
      type,
      address,
      postal_code,
      address_proof: filePreview,
      proof: filePreviewProof,
      address_proof_type_id,
      company_name,
      registration_num,
      proof_type_id,
      id: kycData?.id,
      vat_id,
      personal_tax_id,
    };
    mutateUpdate(payload);
  }

  const handleChangeFile = async (event, type = 'address_proof') => {
    setIsLoading(type);
    const files = event.currentTarget.files;
    if (!files) return;
    const formData = new FormData();
    let filesArr = [];
    for (let file of files) {
      formData.append('media', file);
      try {
        const res = await fetchMediaURL(formData);
        if (res?.data?.success) {
          filesArr.push(res?.data?.data);
        }
      } catch (error) {
        console.error({ error });
        setIsLoading(null);
      }
    }
    setIsLoading(null);

    if (type === 'address_proof') {
      setFilePreview((prevState) => [...prevState, ...filesArr]);
      formik.setFieldValue('address_proof', files);
    }
    if (type === 'proof') {
      setFilePreviewProof((prevState) => [...prevState, ...filesArr]);
      formik.setFieldValue('proof', files);
    }
  };

  useEffect(() => {
    if (kycData && Object.keys(kycData).length > 0) {
      const {
        first_name = '',
        last_name = '',
        user_city = '',
        user_country = '',
        address = '',
        postal_code = '',
        address_proof = [],
        proof = [],
        company_name = '',
        registration_num = '',
        address_proof_type_id = '',
        proof_type_id = '',
        type = '',
        vat_id = '',
        personal_tax_id = '',
      } = kycData;
      console.log({ kycData });
      const valuesToSet = {
        first_name,
        last_name,
        user_city,
        user_country,
        address,
        postal_code,
        address_proof,
        company_name,
        address_proof_type_id,
        proof_type_id,
        type,
        registration_num,
        vat_id,
        personal_tax_id,
      };
      setFilePreview(address_proof || []);
      setFilePreviewProof(proof || []);
      setInitialValues(valuesToSet);
    } else {
      setFilePreview([]);
      setFilePreviewProof([]);
      setInitialValues(initialState);
    }
  }, [kycData]);

  const handleRemoveFile = (index, name) => {
    const tempFiles =
      name === 'address_proof'
        ? [...filePreview]
        : name === 'proof'
          ? [...filePreviewProof]
          : [];
    const filterFiles = tempFiles.filter((_, idx) => idx !== index);
    if (name === 'address_proof') setFilePreview([...filterFiles]);
    if (name === 'proof') setFilePreviewProof([...filterFiles]);
  };

  return (
    <Modal
      size="md"
      centered
      show={viewKyc}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            Update KYC Details
          </h5>
        </div>

        <div
          className="modal-body overflow-auto "
          style={{
            maxHeight: 'calc(100vh - 200px)',
          }}
        >
          <div className="form-group input_control">
            <div className="w-100">
              <label className="form-label">Profile Type</label>
              <select
                className="form-control"
                name="type"
                onChange={(e) => {
                  formik.handleChange(e);
                  formik.setFieldValue('company_name', '');
                  formik.setFieldValue('registration_num', '');
                  formik.setFieldValue('vat_id', '');
                  formik.setFieldValue('personal_tax_id', '');
                }}
                onBlur={formik.handleBlur}
                value={formik.values.type}
              >
                <option value="Personal">Personal</option>
                <option value="Business">Business</option>
              </select>
              {formik.touched.type && formik.errors.type ? (
                <div className="error_required">{formik.errors.type}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <label htmlFor="first_name" className="form-label">
                First Name
              </label>
              <input
                className="form-control"
                placeholder="First Name"
                name="first_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.first_name}
                id="first_name"
              />
              {formik.touched.first_name && formik.errors.first_name ? (
                <div className="error_required">{formik.errors.first_name}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <label htmlFor="last_name" className="form-label">
                Last Name
              </label>
              <input
                className="form-control"
                placeholder="Last Name"
                name="last_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.last_name}
                id="last_name"
              />
              {formik.touched.last_name && formik.errors.last_name ? (
                <div className="error_required">{formik.errors.last_name}</div>
              ) : null}
            </div>
          </div>
          {formik.values.type === 'Business' && (
            <>
              <div className="form-group input_control input_control--gap">
                <div className="w-100">
                  <label className="form-label">Company Name</label>
                  <input
                    className="form-control"
                    placeholder="Company Name"
                    name="company_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.company_name}
                  />
                  {formik.touched.company_name && formik.errors.company_name ? (
                    <div className="error_required">
                      {formik.errors.company_name}
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          )}
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <label className="form-label">Address</label>
              <input
                className="form-control"
                placeholder="Address"
                name="address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address}
              />
              {formik.touched.address && formik.errors.address ? (
                <div className="error_required">{formik.errors.address}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <label className="form-label">User City</label>
              <input
                className="form-control"
                placeholder="User City"
                name="user_city"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.user_city}
              />
              {formik.touched.user_city && formik.errors.user_city ? (
                <div className="error_required">{formik.errors.user_city}</div>
              ) : null}
            </div>
          </div>
          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <label className="form-label">User Country</label>
              <select
                className="form-control"
                name="user_country"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.user_country}
              >
                <option value="">Please Select Country</option>
                {Country.getAllCountries().map(({ isoCode, name }) => (
                  <option key={isoCode} value={isoCode}>
                    {name}
                  </option>
                ))}
              </select>
              {formik.touched.user_country && formik.errors.user_country ? (
                <div className="error_required">
                  {formik.errors.user_country}
                </div>
              ) : null}
            </div>
          </div>

          {formik.values.type === 'Business' ? (
            <>
              <div className="form-group input_control input_control--gap">
                <div className="w-100">
                  <label className="form-label">
                    Company Registration Number
                  </label>
                  <input
                    className="form-control"
                    placeholder="Company Registration Number"
                    name="registration_num"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.registration_num}
                  />
                  {formik.touched.registration_num &&
                    formik.errors.registration_num ? (
                    <div className="error_required">
                      {formik.errors.registration_num}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="form-group input_control input_control--gap">
                <div className="w-100">
                  <label htmlFor="vat_id" className="form-label">
                    VAT Number
                  </label>
                  <input
                    className="form-control"
                    placeholder="VAT Number"
                    name="vat_id"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.vat_id}
                    id="vat_id"
                  />
                  {formik.touched.vat_id && formik.errors.vat_id ? (
                    <div className="error_required">{formik.errors.vat_id}</div>
                  ) : null}
                </div>
              </div>
              <div className="form-group input_control input_control--gap">
                <div className="w-100">
                  <label htmlFor="personal_tax_id" className="form-label">
                    TAX Number
                  </label>
                  <input
                    className="form-control"
                    placeholder="TAX Number"
                    name="personal_tax_id"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.personal_tax_id}
                    id="personal_tax_id"
                  />
                  {formik.touched.personal_tax_id &&
                    formik.errors.personal_tax_id ? (
                    <div className="error_required">
                      {formik.errors.personal_tax_id}
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ) : null}

          <div className="form-group input_control input_control--gap">
            <div className="w-100">
              <label className="form-label">Postal Code</label>
              <input
                className="form-control"
                placeholder="Postal Code"
                name="postal_code"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.postal_code}
              />
              {formik.touched.postal_code && formik.errors.postal_code ? (
                <div className="error_required">
                  {formik.errors.postal_code}
                </div>
              ) : null}
            </div>
          </div>

          <div className="form-group input_control">
            <div className="w-100">
              <label className="form-label">Address Proof Type</label>
              <select
                className="form-control"
                name="address_proof_type_id"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address_proof_type_id}
              >
                <option value="">Please Select Type</option>
                {dataAddressProofType && dataAddressProofType?.length > 0 ? (
                  dataAddressProofType.map((res, index) => {
                    return (
                      <option key={index} value={res?.id}>
                        {res?.attributes?.name}
                      </option>
                    );
                  })
                ) : (
                  <option>No record found</option>
                )}
              </select>
              {formik.touched.address_proof_type_id &&
                formik.errors.address_proof_type_id ? (
                <div className="error_required">
                  {formik.errors.address_proof_type_id}
                </div>
              ) : null}
            </div>
          </div>

          <PreviewImages
            {...{
              title: 'Address Proof:',
              name: 'address_proof',
              data: filePreview,
              handleRemoveFile,
              handleChangeFile,
              isLoading,
              ref: fileRef,
            }}
          />
          <div className="form-group input_control">
            <div className="w-100">
              <label className="form-label">{`${formik?.values?.type} Proof Type`}</label>
              <select
                className="form-control"
                name="proof_type_id"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.proof_type_id}
              >
                <option value="">Please Select Type</option>
                {dataProofTypeID && dataProofTypeID?.length > 0 ? (
                  dataProofTypeID.map((res, index) => {
                    return (
                      <option key={index} value={res?.id}>
                        {res?.attributes?.name}
                      </option>
                    );
                  })
                ) : (
                  <option>No record found</option>
                )}
              </select>
              {formik.touched.proof_type_id && formik.errors.proof_type_id ? (
                <div className="error_required">
                  {formik.errors.proof_type_id}
                </div>
              ) : null}
            </div>
          </div>

          {typeOfProfile && (
            <PreviewImages
              {...{
                title: `${typeOfProfile} Proof`,
                name: 'proof',
                data: filePreviewProof,
                handleRemoveFile,
                handleChangeFile,
                isLoading,
                ref: fileProofRef,
              }}
            />
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn btn-warning"
            disabled={isLoadingUpdate || isLoading}
          >
            {isLoadingUpdate ? 'Please Wait...' : 'Submit'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default KycEditModal;
